import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/img01.jpeg'
import HeaderSocial from './header_social'
const header = () => {
    return (
        <header>
            <div className="container header_container">
                <h5>Hello I'm </h5>
                <h1>Sophia Jeospeh</h1>
                <h5 className="text-light">I'm a Full-Stack Developer</h5>
                <CTA />
                <HeaderSocial/>
                <div className="me">
                    <img src= {ME} alt="" />
                </div>
                <a href="#contact" className='scroll'>Scroll Down </a>
            </div>
        </header>
    )
}

export default header
